// extracted by mini-css-extract-plugin
export var chevron = "_k1-4";
export var chevronExpanded = "_k1-5";
export var row = "_k1-0";
export var rowBody = "_k1-6";
export var rowDescription = "_k1-7";
export var rowHeader = "_k1-1";
export var rowTitle = "_k1-2";
export var rowTitleComplete = "_k1-3";